@if(isOpen)
{
<div class="relative w-full rounded-xl border border-border shadow-md">
    <div class="p-6 flex flex-col gap-2">
        <p class="font-bold text-lg">
            @if(isEditing) { {{ 'admin.edit' | transloco }} }
            @else { {{ 'admin.new' | transloco }} }
            {{ 'admin.opportunities' | transloco }}</p>

        <!-- Name -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-labeled-input labelText="{{ 'admin.name' | transloco }}" [inputId]="'name'" [inputType]="'text'"
                [(inputValue)]="nameInput" [errorMessage]="nameInputError"
                placeholder="{{ 'admin.placeholders.eg_remainining_contract_duration' | transloco }}"></app-labeled-input>
        </div>

        <!-- Product/Service -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-custom-dropdown [options]="productsDropdownOptions" label="{{ 'admin.product_service' | transloco }}"
                [(selectedOption)]="selectedProductDropdown">
            </app-custom-dropdown>
        </div>

        <!-- Description -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-textarea-input labelText="{{ 'admin.description' | transloco }}" [inputId]="'description'"
                [(textValue)]="descriptionInput" [errorMessage]="descriptionInputError" [rows]="3"></app-textarea-input>
        </div>

        <!-- Sales Prompt -->
        <div class="min-w-[250px] max-w-ultrawide">
            <app-textarea-input labelText="{{ 'admin.sales_prompt' | transloco }}"
                placeholder="{{ 'admin.sales_prompt_placeholder' | transloco}}" [inputId]="'description'"
                [(textValue)]="salesPromptInput" [errorMessage]="salesPromptInputError" [rows]="3"></app-textarea-input>
        </div>

        <div class="w-full max-w-ultrawide my-6">
            <div class="flex items-center justify-between mb-2">
                <h3 class="text-base font-semibold">{{ 'admin.signals' | transloco }}</h3>

                <!-- Add Existing Signal -->
                <button type="button" (click)="openPicker()" class="text-blue-500 hover:text-blue-800 text-sm">
                    {{ 'admin.add_existing_signal' | transloco}}
                </button>
            </div>

            <!-- PICKER VIEW -->
            <div *ngIf="showPicker" class="rounded-xl border border-border bg-blue-50 bg-primary-50 p-4">
                <p class="text-sm text-neutral-700 mb-3">{{ 'admin.select_existing_signal' | transloco }}:</p>

                <div class="flex flex-col gap-3 max-h-[360px] overflow-auto pr-1">
                    <button *ngFor="let s of availableSignals" type="button" (click)="pickSignal(s)"
                        class="text-left rounded-xl border border-border bg-[#FFFFFF] hover:bg-blue-50 hover:border-blue-500 px-4 py-3">
                        <p class="font-medium text-neutral-900">{{ s.name }}</p>
                        <p class="text-sm text-neutral-500" *ngIf="s.description">{{ s.description }}</p>
                    </button>

                    <p *ngIf="availableSignals.length === 0" class="text-sm text-neutral-500">
                        {{'admin.all_signals_selected' | transloco}}
                    </p>
                </div>

                <button type="button" (click)="cancelPicker()"
                    class="mt-4 text-sm text-neutral-600 hover:text-neutral-800">
                    {{'shared.cancel' | transloco}}
                </button>
            </div>

            <!-- LIST VIEW -->
            <div class="flex flex-col gap-2 mt-4 p-4 rounded-xl border-border border-2 border-dashed">
                <!-- Selected signals list -->
                <div *ngFor="let s of selectedSignals"
                    class="flex items-start justify-between gap-3 rounded-xl border border-border bg-neutral-50 px-4 py-3">
                    <div class="flex-1">
                        <p class="font-semibold text-neutral-800">{{ s.name }}</p>
                        <p class="text-sm text-neutral-500" *ngIf="s.description">{{ s.description }}</p>
                    </div>

                    <button type="button" (click)="removeSignal(s.id)"
                        class="px-3 py-1 rounded-full bg-white hover:bg-neutral-100 border border-border text-neutral-700">
                        {{ 'admin.remove' | transloco }}
                    </button>
                </div>

                <p *ngIf="selectedSignals.length === 0" class="text-sm text-neutral-500">
                    {{ 'admin.no_signals' | transloco }}
                </p>
            </div>
        </div>

        <div class="flex gap-2 flex-wrap min-w-[300px]">
            <div class="h-[45px] w-[150px]">
                @if(isEditing)
                {
                <app-custom-button buttonText="{{ 'admin.update' | transloco }}" backgroundColor="bg-primary"
                    textColor="text-white" borderColor="border-primary" (buttonClick)="confirmButtonClick()"
                    hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>}
                @else {
                <app-custom-button buttonText="{{ 'admin.create' | transloco }}" backgroundColor="bg-primary"
                    textColor="text-white" borderColor="border-primary" (buttonClick)="confirmButtonClick()"
                    hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>}
            </div>

            <div class="h-[45px] w-[150px]">
                <app-custom-button buttonText="{{ 'shared.cancel' | transloco }}" backgroundColor="bg-[#FFFFFF]"
                    textColor="text-secondary" borderColor="border-secondary" hoverBackgroundColor="hover:bg-secondary"
                    hoverBorderColor="hover:border-secondary" (buttonClick)="closeView()"></app-custom-button>
            </div>
        </div>
    </div>
</div>
}